<template>
    <v-navigation-drawer id="app-drawer" v-model="inputValue" app dark floating persistent mobile-break-point="991" width="260">
        <v-img :src="image" height="100%">
            <v-layout class="fill-height" tag="v-list" column>
                <v-list-tile avatar>
                    <v-list-tile-avatar color="white">
                        <v-img :src="logo" height="34" contain />
                    </v-list-tile-avatar>
                    <v-list-tile-title class="title">FreeTour</v-list-tile-title>
                </v-list-tile>

                <v-divider/>

                <v-list-tile to="/dashboard" :active-class="color" avatar class="v-list-item">
                    <v-list-tile-action>
                        <v-icon>mdi-view-dashboard</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>Home</v-list-tile-title>
                </v-list-tile>

                <v-list-group :value="false" class="v-list-item">
                    <v-list-tile slot="activator">
                        <v-list-tile-title>Graficas</v-list-tile-title>
                    </v-list-tile>




                    <v-list-tile v-for="(link, i) in graficas" :key="i" :to="link.to" :active-class="color" avatar class="v-list-item">
                        <v-list-tile-action>
                            <v-icon>{{ link.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title v-text="link.text"/>
                    </v-list-tile>



                </v-list-group>

                <v-divider/>

                <v-list-tile to="/recogidas" :active-class="color" avatar class="v-list-item">
                    <v-list-tile-action>
                        <v-icon>mdi-currency-eur</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>Recogidas</v-list-tile-title>
                </v-list-tile>

                <v-divider/>

                <v-list-tile to="/logout" :active-class="color" avatar class="v-list-item">
                    <v-list-tile-action>
                        <v-icon>mdi-exit-to-app</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>Salir</v-list-tile-title>
                </v-list-tile>

            </v-layout>
        </v-img>
    </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapMutations,
    mapState
  } from 'vuex'

  export default {
    data: () => ({
      logo: './img/icon-32.png',
      graficas: [
        {
          to: '/graficas/personas',
          icon: 'mdi-chart-bar',
          text: 'Personas/Económico'
        },
        {
          to: '/graficas/comparativas',
          icon: 'mdi-chart-line',
          text: 'Comparativas'
        },
        {
          to: '/graficas/datos',
          icon: 'mdi-pencil-box-outline',
          text: 'Insertar Datos'
        },
        {
          to: '/graficas/empleados',
          icon: 'mdi-account-multiple',
          text: 'Empleados'
        }
      ],
      links: [
        {
          to: '/dashboard',
          icon: 'mdi-view-dashboard',
          text: 'Dashboard'
        },
        {
          to: '/user-profile',
          icon: 'mdi-account',
          text: 'User Profile'
        },
        {
          to: '/table-list',
          icon: 'mdi-clipboard-outline',
          text: 'Table List'
        },
        {
          to: '/typography',
          icon: 'mdi-format-font',
          text: 'Typography'
        },
        {
          to: '/icons',
          icon: 'mdi-chart-bubble',
          text: 'Icons'
        },
        {
          to: '/maps',
          icon: 'mdi-map-marker',
          text: 'Maps'
        },
        {
          to: '/notifications',
          icon: 'mdi-bell',
          text: 'Notifications'
        }
      ],
      responsive: true
    }),
    computed: {
      ...mapState('app', ['image', 'color']),
      inputValue: {
        get () {
          return this.$store.state.app.drawer
        },
        set (val) {
          this.setDrawer(val)
        }
      },
      items () {
        return this.$t('Layout.View.items')
      }
    },
    mounted () {
      this.onResponsiveInverted()
      window.addEventListener('resize', this.onResponsiveInverted)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResponsiveInverted)
    },
    methods: {
      ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
      onResponsiveInverted () {
        if (window.innerWidth < 991) {
          this.responsive = true
        } else {
          this.responsive = false
        }
      }
    }
  }
</script>

<style lang="scss">
    #app-drawer {
        .v-list__tile {
            border-radius: 4px;

            &--buy {
                margin-top: auto;
                margin-bottom: 17px;
            }
        }

        .v-image__image--contain {
            top: 9px;
            height: 60%;
        }

        .search-input {
            margin-bottom: 30px !important;
            padding-left: 15px;
            padding-right: 15px;
        }
    }
</style>
